import React, { useEffect } from "react";
import { Permission } from "../Permission";
import { useNavigate } from "react-router-dom";
import usePermission from "../../../../hooks/usePermission";
import { FeatureStatic } from "../../../../@types/statics/feature.static";

export const CreateGroup: React.FC = () => {
  const navigate = useNavigate();
  const permissions = usePermission(FeatureStatic.permissions.id);

  useEffect(() => {
    if (!permissions.canView()) {
      navigate("/unauthorized");
      return;
    }
  }, []);

  return (
    <div>
      <Permission pageType="create" />
    </div>
  );
};
